import { Injectable, inject } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../../environments/environment';
import {Observable} from 'rxjs';
import { Variavel } from '../model/variavel/variavel.model';
import { VariavelSelect } from '../model/variavel/variavel-select.model';

@Injectable({
  providedIn: 'root'
})
export class VariavelService {
  private readonly http = inject(HttpClient);

  urlBase = `${environment.urlBase}/variavel`;

  salvarVariavel(variavel: Variavel): Observable<number> {
    return this.http.post<number>(this.urlBase, variavel);
  }

  buscarVariaveisPeloGrupo(): Observable<Variavel[]> {
    return this.http.get<Variavel[]>(this.urlBase);
  }

  buscarVariavelSelect(): Observable<VariavelSelect[]> {
    return this.http.get<VariavelSelect[]>(`${this.urlBase}/select`);
  }

  buscarVariavelSelectComFiltroPesquisa(isPesquisa: boolean): Observable<VariavelSelect[]> {
    return this.http.get<VariavelSelect[]>(`${this.urlBase}/select-filtro-pesquisa/${isPesquisa}`);
  }

  buscarVariavelSelectSessao(sessaoId: number): Observable<VariavelSelect[]> {
    return this.http.get<VariavelSelect[]>(`${this.urlBase}/select/sessao/${sessaoId}`);
  }

  buscarVariaveisDoFluxo(idFluxo: number): Observable<VariavelSelect[]> {
    return this.http.get<VariavelSelect[]>(`${this.urlBase}/fluxo/${idFluxo}`);
  }

  buscarVariaveisDoFluxoAteEtapaAtual(idFluxo: number, idEtapa: number): Observable<VariavelSelect[]> {
    return this.http.get<VariavelSelect[]>(`${this.urlBase}/fluxo/${idFluxo}/etapa/${idEtapa}`);
  }

}
